import { type ReactNode } from 'react';
import { type FormQuestion } from '../data/questions';

type Props = {
  question: FormQuestion;
  stepper?: ReactNode;
};

export function QuestionHeader({ question, stepper }: Props): ReactNode {
  const Icon = question.icon;
  return (
    <div className="flex flex-col items-center text-center">
      <Icon size={28} className="text-brand-red" strokeWidth={1.75} />
      <h2 className="mt-xs font-display text-base font-semibold text-text-primary">
        {question.title}
      </h2>
      {stepper && <div className="mt-sm">{stepper}</div>}
      <p className="mt-md text-sm font-medium text-text-primary sm:mt-lg sm:text-base">
        {question.question}
      </p>
    </div>
  );
}
